<template>
  <chart :options="options" />
</template>

<script>
import { Chart } from 'highcharts-vue'
import Highcharts from 'highcharts'
import exportingInit from 'highcharts/modules/variable-pie'
exportingInit(Highcharts)

export default {
  components: {
    Chart
  },
  props: {
    data: {
      type: Object,
      default: () => {}
    },
    size: {
      type: Number,
      default: 240
    },
    title: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      options: {
        colors: ['#13a2e8'],
        chart: {
          width: 800,
          height: 400,
          type: 'column',
          style: {
            fontFamily: 'BwGlennSans-Regular',
            fontSize: '8px'
          }
        },
        title: {
          text: '',
          style: {
            display: 'none'
          }
        },
        subtitle: {
          text: '',
          style: {
            display: 'none'
          }
        },
        xAxis: {
          categories: this.data.x
        },
        yAxis: {
          title: {
            text: ''
          }
        },
        tooltip: {
          headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
          pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' + '<td style="padding:0"><b>{point.y:.0f} TL</b></td></tr>',
          footerFormat: '</table>',
          shared: true,
          useHTML: true,
          style: {
            fontFamily: 'BwGlennSans-Regular',
            fontSize: '14px'
          }
        },
        plotOptions: {
          column: {
            pointPadding: 0.2,
            borderWidth: 0,
            style: {
              fontFamily: 'BwGlennSans-Medium',
              fontSize: '11px',
              color: 'white',
              textOutline: false
            }
          }
        },
        series: [
          {
            name: this.data.name,
            data: this.data.y
          }
        ],
        legend: {
          enabled: false
        },
        credits: {
          enabled: false
        }
      }
    }
  }
}
</script>